import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { create } from 'zustand'

export type LaneTask = { taskId: Id<'nodes'>; title: string; mustDoOn: string }

// A commit that hit the 3-task limit, waiting on "which one can wait?".
export type FullLane = { taskId: Id<'nodes'>; day: 'today' | 'tomorrow'; lane: LaneTask[] }

export const useMustDoStore = create<{
  full: FullLane | null
  setFull: (full: FullLane | null) => void
}>((set) => ({
  full: null,
  setFull: (full) => set({ full }),
}))
